import { UserData } from '../../models/list-data/user_data';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { RecordForm } from '../../models/peripherals/record_form';
import { JwtHelper } from 'angular2-jwt';
import { ConfirmPopupComponent } from '@shared/modal-popup/confirm-popup/confirm-popup.component';
@Component({
  selector: 'app-recordmanagerarray',
  templateUrl: './recordmanagerarray.component.html',
  styleUrls: ['./recordmanagerarray.component.css']
})
export class RecordmanagerarrayComponent implements OnInit {
  @ViewChild(ConfirmPopupComponent) confirmModal: ConfirmPopupComponent;
  public isCollapsed = true;
  recordCounter: number;
  selectedRecordMgr: any[] = [];
  currentUserDetail;
  currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

  @Input()
  public recordForm: RecordForm[];

  @Input()
  public recordFormArray: FormArray;

  @Input()
  public userData: UserData[];

  rows: number;

  @Input()
  public parentId: number;

  @Output() deleteRecordEvent: EventEmitter<number> = new EventEmitter();

  constructor(private jwtHelper: JwtHelper) {

  }

  static buildRecords(defaultValue) {
    return new FormArray([
      this.buildRecord('Primary', defaultValue),
    ]);
  }
  static buildFormRecord(val: RecordForm): any {
    return new FormGroup({
      recordType: new FormControl(val.recordType),
      recordId: new FormControl(val.recordId),
      record: new FormControl(val.record)
    });
  }

  static buildRecord(label: string, value: any): any {




    let form: FormGroup = new FormGroup({
      recordType: new FormControl({ value: label }),
      recordId: new FormControl({ value: value }),
      record: new FormControl(null)
    });



    form.controls['recordType'].setValue(label, { onlySelf: true });

    if (value !== undefined) {
      form.controls['recordId'].setValue(value, { onlySelf: true });
    } else {
      form.controls['recordId'].setValue(undefined, { onlySelf: true });
    }
    return form;
  }
  addRecord() {
    this.recordFormArray.push(RecordmanagerarrayComponent.buildRecord('Secondary', undefined));
    this.isCollapsed = false;
    this.recordCounter = this.recordCounter + 1;
  }

  ngOnInit() {
    if (JSON.parse(sessionStorage.getItem('selectedRecordMgr')) && JSON.parse(sessionStorage.getItem('selectedRecordMgr')).length > 0) {
      this.selectedRecordMgr = JSON.parse(sessionStorage.getItem('selectedRecordMgr'));
    }

    this.currentUserDetail = this.jwtHelper.decodeToken(this.currentUser.token);
    if (!this.checkRecordMgr(this.currentUserDetail.userId.toString())) {
      // this.selectedRecordMgr.push(this.currentUserDetail.userId.toString());
      sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    }
    if(this.selectedRecordMgr.length == 0){
      this.selectedRecordMgr.push(this.currentUserDetail.userId.toString());
      sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    }

    if (this.recordForm) {

      this.recordFormArray.removeAt(0);
      this.recordForm.forEach(element => {

        // this.recordFormArray.push(RecordmanagerarrayComponent.buildRecord(element.record, element.recordId));
        this.recordFormArray.push(RecordmanagerarrayComponent.buildFormRecord(element));
      });
    }
    this.recordCounter = this.recordForm.length;
  }

  setRecordID() {

  }

  deleteRecord(index) {

    let recordId = this.recordFormArray.controls[index.map_id].get('record').value;


    if (this.parentId) {

      this.recordFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
      if (recordId) {
        this.deleteRecordEvent.emit(recordId);
      }
      this.selectedRecordMgr = JSON.parse(sessionStorage.getItem('selectedRecordMgr'));
      this.selectedRecordMgr.splice(index.map_id, 1);
      sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    } else {
      this.recordFormArray.removeAt(index.map_id);
      this.confirmModal.closeModal();
      this.selectedRecordMgr = JSON.parse(sessionStorage.getItem('selectedRecordMgr'));
      this.selectedRecordMgr.splice(index.map_id, 1);
      sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    }
    this.recordCounter = this.recordCounter - 1;
  }
  setRecordMgr(value, index) {
    if (JSON.parse(sessionStorage.getItem('selectedRecordMgr')) && JSON.parse(sessionStorage.getItem('selectedRecordMgr')).length > 0) {
      this.selectedRecordMgr = JSON.parse(sessionStorage.getItem('selectedRecordMgr'));
    }

    // if (JSON.parse(sessionStorage.getItem('selectedRecordMgr')) &&
    //   this.recordCounter === JSON.parse(sessionStorage.getItem('selectedRecordMgr')).length) {

      this.selectedRecordMgr[index] = value;
      sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    // } else {
    //   this.selectedRecordMgr[index] = value;
    //   sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    // }
    let selected = this.selectedRecordMgr.find(function (element) {
      //
      return element === value;
    });
    if (selected === undefined) {
      this.selectedRecordMgr.push(value);
      sessionStorage.setItem('selectedRecordMgr', JSON.stringify(this.selectedRecordMgr));
    }
  }
  checkRecordMgr(value) {
    if (JSON.parse(sessionStorage.getItem('selectedRecordMgr')) && JSON.parse(sessionStorage.getItem('selectedRecordMgr')).length > 0) {
      this.selectedRecordMgr = JSON.parse(sessionStorage.getItem('selectedRecordMgr'));
    }
    value = value.toString();
    return this.selectedRecordMgr.includes(value);
  }

  openConfirm(id) {
    this.confirmModal.showModal(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/record-manager-form-control/recordmanagerarray.component.ts